@if (open()) {
  <!-- Backdrop -->
  <div class="fixed inset-0 z-40 bg-black/50" (click)="close()"></div>

  <!-- Drawer -->
  <nav class="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-cd-outline shadow-cd-sidebar">
    <div class="flex items-center justify-around h-14">
      <a routerLink="/" routerLinkActive="text-cd-primary" [routerLinkActiveOptions]="{exact: true}"
         (click)="close()"
         class="flex flex-col items-center gap-0.5 px-3 py-1 text-cd-on-surface-var">
        <span class="material-symbols-outlined text-xl">home</span>
        <span class="text-[10px] font-medium">Home</span>
      </a>
      <a routerLink="/" fragment="features"
         (click)="close()"
         class="flex flex-col items-center gap-0.5 px-3 py-1 text-cd-on-surface-var">
        <span class="material-symbols-outlined text-xl">auto_awesome</span>
        <span class="text-[10px] font-medium">Features</span>
      </a>
      <a routerLink="/pricing" routerLinkActive="text-cd-primary"
         (click)="close()"
         class="flex flex-col items-center gap-0.5 px-3 py-1 text-cd-on-surface-var">
        <span class="material-symbols-outlined text-xl">payments</span>
        <span class="text-[10px] font-medium">Pricing</span>
      </a>
      <a routerLink="/about" routerLinkActive="text-cd-primary"
         (click)="close()"
         class="flex flex-col items-center gap-0.5 px-3 py-1 text-cd-on-surface-var">
        <span class="material-symbols-outlined text-xl">info</span>
        <span class="text-[10px] font-medium">About</span>
      </a>
    </div>
  </nav>
}
